import { Configuration } from "./configuration";

export class ApiFactory {
    private static configuration = new Configuration();
    private static basePath = process.env.REACT_APP_API_URL;
    private static instances = new Map<string, any>();

  public static get<T>(
    apiService: new (configuration: Configuration, basePath: string) => T
  ): T {
    const className = apiService.name;

    if (!this.instances.has(className)) {
        if (!this.basePath) {
            throw new TypeError("Не задан base_url в окружении");
        }

        this.instances.set(
            className,
            new apiService(this.configuration, this.basePath)
        );
    }

    return this.instances.get(className) as T;
  }
}
